import React from "react";

import {
  Box,
  Input,
  Button,
  styled,
  Dialog,
  TextField
  // Customizable Area End
} from "@material-ui/core";

// Customizable Area Start
import { colors } from "../../utilities/src/Colors";
import CustomLoader from "../../../components/src/customComponents/CustomLoader.web";
import { barCodeImg } from "./assets";
import { trim } from "lodash";
// Customizable Area End

import BarcodesScannerController, {
  Props,
  configJSON,
} from "./BarcodesScannerController";

export default class GarmentTagScanner extends BarcodesScannerController {
  render() {
    console.log("GarmentTagScanner rendered");

    return (
     <Box
  display="flex"
  flexDirection="column"
  justifyContent="center"
  alignItems="center"
  padding={2}
  border="1px solid #ddd"
  borderRadius={12}
  width="100%"
  maxWidth={400} 
>
  <CustomLoader loading={Boolean(this.props.loading)} />

  <h3>Scan Order or Tag Barcode</h3>

  <img src={barCodeImg} alt="barcode" />

  <p>Scan the barcode or type the order or tag number:</p>

  <TextField
    autoFocus
    label="Order Number"
    value={this.state.txtInputValue}
    onChange={(e) => this.setInputValue(trim(e.target.value))}
    onKeyPress={this.handlePress}
    fullWidth
  />

 <Box display="flex" justifyContent="center" mt={2}>
  <Button
    className="cancel-btn"
    onClick={this.hanldeClose}
    variant="outlined"
    style={{
      minWidth: 120,
      padding: "10px 20px",
      borderRadius: 8,
      fontWeight: 600,
      marginRight: 16, 
    }}
  >
    Cancel
  </Button>

  <Button
    className="submit-btn"
    onClick={this.handleSubmit}
    variant="contained"
    color="primary"
    style={{
      minWidth: 120,
      padding: "10px 20px",
      borderRadius: 8,
      fontWeight: 600,
    }}
  >
    OK
  </Button>
</Box>


</Box>

    );
  }
}

